import { setTerm } from './helpers';

export const setVillage = setTerm('kp_id');
